// CR49
import React from 'react';
import classnames from 'classnames';
import { withTranslation, WithTranslation } from 'react-i18next';
import InfoIcon from '@wix/da-shared-react/pkg/Icons/Info';
import { IconSize } from '@wix/da-shared-react/pkg/Icons/IconWrap';
import {
  formatDate,
  DATE_FORMATS,
} from '@wix/da-shared-react/pkg/Timestamp/functions';

import s from './Deviousness.scss';

export interface Props {
  className?: string;
  dateAwarded: string;
  description: string;
}

const Deviousness: React.SFC<Props & WithTranslation> = ({
  className,
  dateAwarded,
  description,
  t,
}) => (
  <div className={classnames(s['root'], className)}>
    <div className={s['box']}>
      <a
        className={s['info-link']}
        href="https://www.deviantartsupport.com/en/article/what-is-the-deviousness-award"
        rel="noopener noreferrer nofollow"
        target="_blank"
      >
        <InfoIcon className={s['info-icon']} size={IconSize.MEDIUM} condensed />
      </a>
      <div className={s['crown']} />
      <div className={s['description']}>
        <div
          className={s['dd-text']}
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      </div>
      <div className={s['award-date']}>
        {t('widgets.deviousness.awarded', {
          timestamp: formatDate(dateAwarded, DATE_FORMATS.Date.MonthYear),
        })}
      </div>
    </div>
  </div>
);
Deviousness.displayName = 'Deviousness';

export default withTranslation()(Deviousness);
